import React from "react"
import Header from "./header"
import "./layout.css"

const Layout = ({
  children,
  headerData,
  isMusic = false,
  showThoughtsNav = false,
}) => {
  return (
    <>
      <Header
        headerData={headerData}
        isMusic={isMusic}
        showThoughtsNav={showThoughtsNav}
      />
      <div style={{}}>
        <main>{children}</main>
      </div>
    </>
  )
}

export default Layout
